module.exports = __webpack_public_path__ + "img/logo_lacentrale_3.png?30d67b6d55b4dd06742882ae07bc5f81";


//////////////////
// WEBPACK FOOTER
// ./public/img/logo_lacentrale_3.png
// module id = 21
// module chunks = 0